<template>
	<div>
		<add-idea v-if="problem.status != 'resolved'" :post="post" :placeholder="$vuetify.lang.t('$vuetify.views.wall.problem.startAddIdea')" @added="problemIdeaAdded"/>
		<div class="mt-3">
			<problem-idea-item v-for="(idea, index) in sortedIdeas" :key="index" :idea="idea" :post="post" class="mt-3"/>
		</div>
	</div>
</template>

<script>
import AddIdea from "./AddIdea"
import ProblemIdeaItem from "./ProblemIdeaItem"
import _ from 'lodash';
export default {
	components: {
		AddIdea,
		ProblemIdeaItem
	},
	props: {
		post: {
			type: Object,
			required: true
		}
	},
	computed: {
		problem() {
			return this.post.postable;
		},
		sortedIdeas() {
			return _.orderBy(this.problem.problem_ideas, 'created_at', 'desc');
		}
	},
	methods: {
		problemIdeaAdded(problem) {
			this.$emit('added', problem);
		}
	}
}
</script>